import toggleProgramSource from '@shoflo/studio-redux/actions/program/toggleProgramSource';
import deleteSource from './deleteSource';
import setProgram from 'actions/program/setProgram';

function removePresenter(sourceValue) {
  return (dispatch, getState) => {
    const {
      broadcastSources,
      program: { layers = [] }
    } = getState();
    const [source] = broadcastSources.sources.filter(
      bs => bs.value === sourceValue
    );

    if (!source) {
      return;
    }

    const { _id: sourceId } = source;
    const [layerSource] = layers.filter(layer => layer.source._id === sourceId);

    // Remove if screen is in program
    if (!!layerSource && !source.hidden) {
      dispatch(toggleProgramSource(source, setProgram));
    }
    dispatch(deleteSource(sourceId));
  };
}

export default removePresenter;
